/** @jsxImportSource @emotion/react */
import styled from "@emotion/styled";
import React, { useEffect, useState } from "react";
import { ILearnisticApp, ILearnisticTag } from "../../generated/Api";
import LearnisticTag from "../LearnisticTag";
import AutoCompleteTag from "./AutoCompleteTag";

const TagsContainer = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 10px;
  flex-wrap: wrap;
  flex-grow: 1;
  position: relative;
`;
interface Props {
  tags: ILearnisticTag[];
  disabled?: boolean;
  handleChoseTags: (tags: ILearnisticTag[]) => void;
  tagsPool: ILearnisticApp[];
}

export default function LearnisticTagSelect(props: Props): JSX.Element {
  const { tags, disabled, handleChoseTags, tagsPool } = props;
  const [tagInputValue, setTagInputValue] = useState("");
  const [tagSuggestions, setTagSuggestions] = useState<ILearnisticTag[]>();

  useEffect(() => {
    let newSuggestions: ILearnisticTag[] = [];

    tagsPool.map((t) => {
      newSuggestions = [...newSuggestions, ...t.tags];
    });

    setTagSuggestions(newSuggestions.filter((tag) => !tags.includes(tag)));
  }, [tags, tagsPool]);

  function handleTagValueSelect({ id, name }: ILearnisticTag) {
    if (name !== "" && tagsPool) {
      const alreadyIn = tags.find((tag) => tag.id === id);
      const tagExists = tagsPool.find((app) =>
        app.tags.find((t) => t.id === id)
      );

      if (!alreadyIn && tagExists) {
        handleChoseTags([...tags, tagExists.tags.find((t) => t.id === id)]);
      }
      setTagInputValue("");
    }
  }

  function deleteTag(elem: ILearnisticTag) {
    handleChoseTags(tags.filter((tag) => tag.id !== elem.id));
  }

  return (
    <div>
      <div style={{ pointerEvents: disabled ? "none" : "auto" }}>
        <AutoCompleteTag
          selectedValue={tagInputValue}
          onValueSelect={handleTagValueSelect}
          onEnter={handleTagValueSelect}
          onValueChange={setTagInputValue}
          placeholder="Search for tag(s)"
          suggestions={tagSuggestions}
          viewCategories={() => {}}
        />
      </div>
      <TagsContainer>
        {tags
          .filter((t) => t)
          .map((elm: ILearnisticTag) => {
            return (
              <LearnisticTag
                key={`recipient_tag_tags_select_${elm.id}`}
                tag={elm}
                deleteTag={deleteTag}
                disabled={disabled}
              />
            );
          })}
      </TagsContainer>
    </div>
  );
}
